// eslint-disable-next-line @typescript-eslint/naming-convention
const LoadingState = {
	INACTIVE: 0,
	ACTIVE: 1
} as const;

type LoadingStateType = (typeof LoadingState)[keyof typeof LoadingState];

export { LoadingState, LoadingStateType };
